/**
 * TanStack Query hooks for `affiliate-referral-builder`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	list,
	upsertProgram,
	deactivateProgram,
	affiliateReferralBuilderQueryKeys,
	type ListAffiliateReferralBuilderResponse,
	type AffiliateReferralProgramRow,
	type UpsertAffiliateReferralBuilderBody,
} from "./api";

export function useAffiliateReferralBuilderList(): UseQueryResult<ListAffiliateReferralBuilderResponse, Error> {
	return useQuery({
		queryKey: affiliateReferralBuilderQueryKeys.list(),
		queryFn: list,
	});
}

export function useAffiliateReferralBuilderCreate(): UseMutationResult<
	{ program: AffiliateReferralProgramRow },
	Error,
	UpsertAffiliateReferralBuilderBody
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: upsertProgram,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateReferralBuilderQueryKeys.all });
		},
	});
}

export function useAffiliateReferralBuilderDelete(): UseMutationResult<
	{ program: AffiliateReferralProgramRow },
	Error,
	string
> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: deactivateProgram,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: affiliateReferralBuilderQueryKeys.all });
		},
	});
}
